"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoPlayButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _link = _interopRequireDefault(require("../link"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _videoLightbox = _interopRequireDefault(require("../../../page-body/media-components/video-lightbox"));
var _react2 = require("@linaria/react");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PlayIconOverrides = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "PlayIconOverrides",
  class: "pl-p1lwhgjp"
});

/**
 * Video Play Button and Lightbox Component
 * @module VideoPlayButton
 *
 * @param {Object} props React props
 * @param {string} props._name The component's tracking name
 * @param {string} props.text The trigger link's text
 * @param {string} props.youTubeId Video Embed Id
 * @param {string} props.lightboxUrl Video URL
 * @param {string} props.ariaLabelCloseButton Eyebrow text
 * @param {Object} props.transcriptButton Heading text
 * @param {Object} props.inverted Invert Video Play Button
 * @param {boolean} props.disableAutoPlay Disable auto play for video and yt
 * @returns {React.ReactElement} Video Play Button and Lightbox Component
 * @public
 */

function VideoPlayButton({
  youTubeId,
  lightboxUrl,
  ariaLabelCloseButton,
  transcriptButton,
  inverted,
  partial,
  disableAutoPlay,
  ...rest
}) {
  const [lightBoxIsOpen, setLightBoxIsOpen] = (0, _react.useState)(false);
  const openLightBox = () => setLightBoxIsOpen(true);
  const closeLightBox = () => setLightBoxIsOpen(false);
  return /*#__PURE__*/_react.default.createElement(PlayIconOverrides, {
    "data-partial": partial || (inverted ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
    design: "icon",
    icon: "media-player",
    dataCy: "video-play-button",
    onClick: openLightBox
  }, rest)), /*#__PURE__*/_react.default.createElement(_videoLightbox.default, {
    youTubeId,
    lightboxUrl,
    showModal: lightBoxIsOpen,
    handleClose: closeLightBox,
    transcriptButton,
    ariaLabelCloseButton,
    disableAutoPlay
  }));
}
VideoPlayButton.propTypes = {
  _name: _propTypes.default.string,
  text: _propTypes.default.string,
  youTubeId: _propTypes.default.string,
  lightboxUrl: _propTypes.default.string,
  ariaLabelCloseButton: _propTypes.default.string,
  transcriptButton: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  inverted: _propTypes.default.bool,
  partial: _propTypes.default.string,
  disableAutoPlay: _propTypes.default.bool
};